export default {
    user : {}
}